<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="_width" :height="_height" :spin="spin" :rtl="rtl" viewBox="0 0 48 48" preserveAspectRatio="xMidYMid meet" fill="" role="presentation" ref="host">
    <g><path data-follow-fill="currentColor" d="M10.5 5.2h27c1.1 0 2 .9 2 2s-.9 2-2 2h-27c-1.1 0-2-.9-2-2s.9-2 2-2zm29.9 8.5H7.6c-2 0-3.6 1.6-3.6 3.6v21.8c0 2 1.6 3.6 3.6 3.6h32.7c2 0 3.6-1.6 3.6-3.6V17.3c.1-2-1.5-3.6-3.5-3.6zm-8.4 19h-6.4v4c0 .9-.8 1.6-1.6 1.6-.9 0-1.6-.7-1.6-1.6v-4H16c-.9 0-1.6-.7-1.6-1.6s.7-1.6 1.6-1.6h6.4v-2.8h-5.3c-.9 0-1.6-.7-1.6-1.6s.8-1.6 1.6-1.6h4.3l-2.6-2.7c-.7-.7-.7-1.7 0-2.3.7-.7 1.7-.7 2.3 0l2.7 2.8 2.7-2.8c.7-.7 1.7-.7 2.4 0s.7 1.7 0 2.3l-2.6 2.7h4.5c.9 0 1.6.7 1.6 1.6s-.7 1.6-1.6 1.6h-5.2v2.8H32c.9 0 1.6.7 1.6 1.6s-.7 1.6-1.6 1.6z" :fill="_fill" /></g>
  </svg>
</template>

<script setup>
import { ref, computed, onMounted, onUpdated } from 'vue';
const props = defineProps({
  width: {
    type: [Number, String],
    required: false
  },
  height: {
    type: [Number, String],
    required: false
  },
  stroke: {
    type: String,
    required: false
  },
  fill: {
    type: String,
    required: false
  },
  color: {
    type: String,
    required: false
  },
  spin: {
    type: Boolean,
    required: false
  },
  rtl: {
    type: Boolean,
    required: false
  }
});
const size = '1em';

const _fill = computed(() => props.fill || props.color || undefined);
const _stroke = computed(() => props.stroke || props.color || undefined);
const _width = computed(() => props.width || size || undefined);
const _height = computed(() => props.height || size || undefined);
const host = ref(null);

onMounted(() => {
  if (!_fill.value) {
    host.value?.querySelectorAll('[data-follow-fill]').forEach((item) => {
      item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
    });
  }
  if (!_stroke.value) {
    host.value?.querySelectorAll('[data-follow-stroke]').forEach((item) => {
      item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
    });
  }
});
onUpdated(() => {
  if (!_fill.value) {
    host.value?.querySelectorAll('[data-follow-fill]').forEach((item) => {
      item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
    });
  }
  if (!_stroke.value) {
    host.value?.querySelectorAll('[data-follow-stroke]').forEach((item) => {
      item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
    });
  }
});
</script>

<style scoped>
svg[spin='true'] {
  animation: iconpark-spin 1s infinite linear;
}

svg[spin='true'][rtl='true'] {
  animation: iconpark-spin-rtl 1s infinite linear;
}

svg[rtl='true'] {
  transform: scaleX(-1);
}
@keyframes iconpark-spin {
  0% {
    -webkit-transform: rotate(0);
    transform: rotate(0);
  }

  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes iconpark-spin-rtl {
  0% {
    -webkit-transform: scaleX(-1) rotate(0);
    transform: scaleX(-1) rotate(0);
  }

  100% {
    -webkit-transform: scaleX(-1) rotate(360deg);
    transform: scaleX(-1) rotate(360deg);
  }
}
</style>
